import CryptoJS from 'crypto-js'

export var token = document.cookie.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1")
export var green = "#40d900"
export var red = "#ff2f2f"
export var colorGreen = "#00a651"
export var colorRed = "#c20303"
export var colorBlue = "#1a4378"
export var currency = "THB"
export var packagelistPage = "/packagelist" //https://ants.co.th/#productlist
export var recaptchakey = "6LfujJwpAAAAAHv6CxLpRiIbZN5vWydnrvEtdp9e"; //dev srv

export var root = ""
export var Title = require('../src/img/Title.svg')
export var Logo_Web = require('../src/img/ANTS3/Logo_Login.png')
export var Logo_Login = require('../src/img/ANTS3/Logo_Login.png')
export var title = require('../src/config.js')
// export var omisekey = "pkey_test_5z8gcek08jdnuppsimf" //dev
export var omisekey = "pkey_5zbm1qg4d95st0s11g5" //prod
export var sellername = "ANTS co th."


export var smsLoginUrl = "https://dev.ants.co.th/sms-for-ecom/#/login"

export function set_cookie(value) {
    document.cookie = value
    token = document.cookie.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1")
};

export function capitalizeFLetter(s) {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
}


export function getUrlVars() {
    var vars = {}
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        vars[key] = value
    })
    return vars

}

export function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email)
}

export function getFileExtension(filename) {
    var ext = /^.+\.([^.]+)$/.exec(filename)
    return ext == null ? "" : ext[1].toLowerCase()
}

export function formatNumber(num) {
    return num ? num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : 0
}

export function parseJwt(token) {
    if (token != "") {
        var base64Url = token.split('.')[1]
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        }).join(''))

        return JSON.parse(jsonPayload)
    } else {
        window.location.href = window.location.protocol + "//" + window.location.host
    }
};

export function getAccId() {
    var token = document.cookie.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1")
    var payload = parseJwt(token)
    if (!payload.id) {
        window.location.href = "/logout"
    }
    return payload.id
}

export function getId() {
    var token = document.cookie.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1")
    var payload = parseJwt(token)
    return payload.primarysid

}

export function getUsername() {
    var token = document.cookie.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1")
    var payload = parseJwt(token)
    return payload.unique_name

}

export function getUserIdname() {
    var token = document.cookie.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1")
    var payload = parseJwt(token)
    return Number(payload.id)

}

export function getPaytype() {
    var token = document.cookie.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1")
    var payload = parseJwt(token)
    return payload.paytype

}

export function getLinkbacklist() {
    var token = document.cookie.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1")
    var payload = parseJwt(token)
    return payload.linkbacklist

}

export function getDefaultPassword() {
    var token = document.cookie.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1")
    var payload = parseJwt(token)
    return payload.defaultPassword

}

export function getTwoFactor() {
    var token = document.cookie.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1")
    var payload = parseJwt(token)
    return payload.twofactor

}

export function getGenToken() {
    var token = document.cookie.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1")
    var payload = parseJwt(token)
    return payload.genToken

}

export function getExpiredDate(token) {
    var payload = parseJwt(token)
    return new Date(payload.exp * 1000)

}

export function deepEqual(object1, object2) {
    const keys1 = Object.keys(object1)
    const keys2 = Object.keys(object2)

    if (keys1.length !== keys2.length) {
        return false
    }

    for (const key of keys1) {
        const val1 = object1[key]
        const val2 = object2[key]
        const areObjects = isObject(val1) && isObject(val2)
        if (
            areObjects && !deepEqual(val1, val2) ||
            !areObjects && val1 !== val2
        ) {
            return false
        }
    }

    return true
}

function isObject(object) {
    return object != null && typeof object === 'object'
}

export function CheckTokenExp() {
    var tokenJwt = document.cookie.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1")
    if (tokenJwt == "") {
        return true
    } else {
        return false
    }
}

export function ReplaceUrlTaga() {
    // add new
    var element = document.getElementsByClassName('ant-breadcrumb-link')
    let start = 0
    let end = element.length
    while (start < end) {
        if (element[start].getElementsByTagName('a')[0] != undefined) {
            element[start].getElementsByTagName('a')[0].attributes[0].nodeValue = element[start].getElementsByTagName('a')[0].attributes[0].nodeValue.replace("#", "")
        }
        start++
    }
}

export function UserInfo() {
    if (document.cookie.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1") != "") {
        var base64Url = token.split('.')[1]
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        }).join(''))

        return JSON.parse(jsonPayload)
    } else {
        window.location.href = window.location.protocol + "//" + window.location.host
    }
};

export function getEmail() {
    var token = document.cookie.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1")
    var payload = parseJwt(token)
    return payload.email
}

export function getMobile() {
    var token = document.cookie.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1")
    var payload = parseJwt(token)
    return payload.mobile
}

export function getPackage() {
    var token = document.cookie.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1")
    var payload = parseJwt(token)
    return payload.package
}

export function getCompany() {
    var token = document.cookie.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1")
    var payload = parseJwt(token)
    return payload.company
}

export function getEnvKey(titleDefault, listDisplayEnvTitle) {
    var token = document.cookie.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1")
    if (token) {
        var payload = parseJwt(token)
        let title = payload.envKey
        //let getTitle = listDisplayEnvTitle.find(t => t.toUpperCase() === title.toUpperCase());
        //return getTitle === undefined ? title : getTitle;
        return title.toUpperCase()
    } else {
        return titleDefault
    }
}

export function formatCurrency(value) {
    return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

export function CheckUserLogedin() {
    var token = document.cookie.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1")
    if (token) {
        var payload = parseJwt(token)
        if (!payload.id) {
            return false
        }
        return true
    } else {
        return false
    }
}

export function encryptText(text, key) {
    const encrypted = CryptoJS.AES.encrypt(text, key).toString();
    return encodeURIComponent(encrypted);
}

export function encryptDES(stringToEncrypt, SEncryptionKey) {
    // ใช้ key 8 byte (DES)
    const key = CryptoJS.enc.Utf8.parse(SEncryptionKey.substring(0, 8));

    // IV แบบเดียวกับ C#: { 0x12, 0x34, ..., 0xef }
    const iv = CryptoJS.enc.Hex.parse("1234567890abcdef");

    const encrypted = CryptoJS.DES.encrypt(stringToEncrypt, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    // คืนค่า Base64 string
    return encrypted.toString();
}

export function encryptAES(stringToEncrypt, SEncryptionKey) {
    const key = CryptoJS.enc.Utf8.parse(SEncryptionKey); // 32 bytes = 256 bit
    const iv = CryptoJS.enc.Hex.parse("1234567890abcdef1234567890abcdef");  // 16 bytes = 128 bit

    const encrypted = CryptoJS.AES.encrypt(stringToEncrypt, key, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
    });

    return encrypted.toString(); // Base64 encoded
}

export function encryptMessage(text, keyStr, ivStr) {
    const key = CryptoJS.enc.Utf8.parse(keyStr.substring(0, 16)); // 16 bytes AES key
    const iv = CryptoJS.enc.Utf8.parse(ivStr); // 16 bytes IV

    const encrypted = CryptoJS.AES.encrypt(text, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.toString(); // Return as Base64 string
}

export function decryptMessage(text, keyStr, ivStr) {
    const key = CryptoJS.enc.Utf8.parse(keyStr.substring(0, 16)); // 16 bytes AES key
    const iv = CryptoJS.enc.Utf8.parse(ivStr); // 16 bytes IV

    const decrypted = CryptoJS.AES.decrypt(text, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    return decrypted.toString(CryptoJS.enc.Utf8); // original text
}

export function encryptId(id, keyStr) {
    try {
        // Convert key (must be same bytes as C# _secretKey)
        const key = CryptoJS.SHA256(keyStr);

        // Generate random IV (16 bytes)
        const iv = CryptoJS.lib.WordArray.random(16);

        // Encrypt ID (string)
        const encrypted = CryptoJS.AES.encrypt(
            id.toString(),
            key,
            { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
        );

        // Prepend IV to ciphertext manually
        const result = iv.clone().concat(encrypted.ciphertext);

        // Convert to Base64
        return CryptoJS.enc.Base64.stringify(result);
    } catch (e) {
        console.error("EncryptId error:", e);
        return "";
    }
}

export function calCredit(content, msgCount, contentlength, messremaining) {
    if (!content.match(/^([a-zA-Z0-9\|!#$%&/()*^=?»«@£§€{}.-;'‘’"“”<>_[\]\\,\-\+ \n\r])+$/i)) {
        msgCount = contentlength <= 70 ? 1 : contentlength <= 134 ? 2 : parseInt(Math.ceil(parseFloat(contentlength) / 67))
        messremaining = contentlength <= 70 ? 70 - contentlength : contentlength <= 134 ? 134 - contentlength : (134 + (67 * (msgCount - 2))) - contentlength
        return { msgCount: msgCount, messremaining: messremaining }
    } else {
        msgCount = contentlength <= 160 ? 1 : contentlength <= 306 ? 2 : parseInt(Math.ceil(parseFloat(contentlength) / 153))
        messremaining = contentlength <= 160 ? 160 - contentlength : contentlength <= 306 ? 306 - contentlength : (306 + (153 * (msgCount - 2))) - contentlength
        return { msgCount: msgCount, messremaining: messremaining }
    }
}